import { AccessDeniedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { StoreItem, StoreItemParams } from "../../domain/usecases/store-item";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbStoreItem implements StoreItem {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async store(params: StoreItemParams): Promise<boolean> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: params,
    });
    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return true;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        return false;
    }
  }
}
